import React from 'react'

function Spinner() {
  return <img style={{ width: 100, objectFit: 'contain' }} src="/images/spinner.gif" alt="loading" />
}

export default Spinner
